export const getResponseTimeValueTextId = (responseTime) => {
  switch (true) {
    case responseTime < 3600:
      return 'responseTimeLessThanOneHour'
    case responseTime < 21600:
      return 'responseTimeFewHours'
    case responseTime < 86400:
      return 'responseTimeOneDay'
    case responseTime < 172800:
      return 'responseTimeSomeDays'
    default:
      return null;
  }
};

export const getAcceptanceRateValueTextId = acceptanceRate => {
  if (acceptanceRate == null) {
    return null;
  }
  if (acceptanceRate < 25)
    return 'acceptanceRateBad';
  if (acceptanceRate < 50)
    return 'acceptanceRateAverage';
  if (acceptanceRate < 75)
    return 'acceptanceRateGood';
  return 'acceptanceRateVeryGood';
};
